import cityLogo from './assets/icons/Turku_logo.png'

export const logo = {
  src: cityLogo,
  alt: 'Turku logo'
}

export const competitionName = 'Historian ja tulevaisuuden museo'

export const infoTableHeaders = [
  {
    header: 'Kaupunkikuvaan ja kaupunkirakenteeseen sovittaminen',
    accessor: 'kaupunkikuvaan_ja_kaupunkirakenteeseen_sovittaminen'
  },
  {
    header:
      'Kokonaistaloudellisuus ja edellytykset elinkaaritavoitteiden täyttymiseen sekä ekologisuus',
    accessor:
      'kokonaistaloudellisuus_ja_edellytykset_elinkaaritavoitteiden_täyttymiseen_sekä_ekologisuus'
  },
  {
    header: 'Kulttuurisen vetovoiman vahvistaminen',
    accessor: 'kulttuurisen_vetovoiman_vahvistaminen'
  },
  {
    header: 'Arkkitehtoniset ja toiminnalliset ratkaisut',
    accessor: 'arkkitehtoniset_ja_toiminnalliset_ratkaisut'
  }
]

export const settingsTabs = [
  { id: 'settings-users', label: 'Users', value: 'users' },
  { id: 'settings-submit-setup', label: 'Submit setup', value: 'submit-setup' },
  { id: 'rating-criteria', label: 'Rating criteria', value: 'rating-criteria' },
  { id: 'settings-tab-setup', label: 'Tab setup', value: 'tab-setup' }
  // { id: 'settings-theme', label: 'Theme', value: 'theme' }
]
